
export interface ISearchState {
  searchStr: string,
  filterBy: string,
}
export const searchState: ISearchState = {
  searchStr: '',
  filterBy: ''
}
